<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.categories', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <hr class="mt-5" />

        <AppWell class="mt-5">
            <div class="md:grid md:grid-cols-3 md:gap-6 mt-5">
                <AppCard>
                    <div class="p-4">
                        <div>
                            {{ $t('messages.import') }}
                        </div>

                        <div>
                            <div class="mt-3" v-for="category in categories" :key="category.id">
                                <div class="mt-5">({{ category.stage_name }})</div>
                                <ConfirmActionButton
                                    :href="category.url"
                                    method="patch"
                                    :confirm-text="$t('messages.import')"
                                    :title="$t('messages.import')"
                                    :button-text="category.text"
                                    :desired-action="!category.is_imported"
                                    :params="importParams"
                                >
                                    <div>({{ category.stage_name }})</div>
                                    <div class="mt-3">
                                        <label class="text-xs">
                                            <input
                                                type="checkbox"
                                                name="show_questions_count"
                                                id=""
                                                v-model="importParams.questions"
                                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                            />
                                            <span>{{ $tc('messages.questions', 2) }}</span>
                                        </label>
                                    </div>
                                </ConfirmActionButton>
                            </div>
                        </div>
                    </div>
                </AppCard>
            </div>
        </AppWell>
    </PanelPage>
</template>

<script>
import PanelPage from '@/Shared/PanelPage.vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import ConfirmActionButton from '@/components/ConfirmActionButton.vue';
import SmartBreadcrumbs from '../../../../components/SmartBreadcrumbs.vue';
import AdminLayout from '../../../../Shared/AdminLayout.vue';

export default {
    components: {
        SmartBreadcrumbs,
        ConfirmActionButton,
        AppCard,
        PanelPage,
        AppWell,
    },
    layout: AdminLayout,
    name: 'Show',
    props: ['meta', 'options', 'widgets', 'school', 'categories', 'featureToggles'],
    data() {
        return {
            importParams: {
                questions: true,
            },
        };
    },
};
</script>
